import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from '../../constants/apiConfig';
import { toast } from 'react-toastify';
// Get Paged Organizations
export const usePagedOrganizations = (
  searchTerm: string,
  offset: number,
  pageSize: number
) => {
  return useQuery({
    queryKey: ['planorganization', searchTerm, offset, pageSize],
    queryFn: async () => {
      const organizations = await axios.get(
        config.apiGateway.getAllOrganizations,
        {
          params: {
            page: offset || 1,
            limit: pageSize || 10,
            term: searchTerm || '',
          },
        }
      );
      return organizations.data;
    },
    throwOnError: (error) => {
      toast.error(error.message);
      return false;
    },
  });
};

type UpdateOrganizationSubscriptionParams = {
  group_guid: string;
  group_name: string;
  subscription_level: string;
  utility_impact?: string;
  quantity: number;
};

export const useUpdateOrganizationSubscription = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (params: UpdateOrganizationSubscriptionParams) => {
      const {
        group_guid,
        group_name,
        subscription_level,
        utility_impact,
        quantity,
      } = params;
      await axios.post(config.apiGateway.updateOrganization, {
        group_guid,
        group_name,
        subscription_level,
        utility_impact,
        quantity: `${quantity}`,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['planorganization'] });
    },
    onError: (error) => {
      toast.error(error.message);
      return false;
    },
  });
};
